/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './css/HotelReviewsModal.css';
import { ReactComponent as Close } from '../../../images/close-r.svg';
import { ReactComponent as BlueArrow } from '../../../images/blue_buttom_arrow-r.svg';
import {
  PLUS,
  MINUS,
  READ_MORE,
  GUEST_REVIEWS,
} from '../../../Utils/Constants/GlobalConstants';
import UserLogo from '../../../images/user-logo-r.png';

function HotelReviewsModal(props) {
  const {
    isVisible,
    reviewModalNode,
    handleReviewModalClick,
    reviews,
    setReviewsState,
  } = props;

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleEscPress = (e) => {
      if (e.key === 'Escape') {
        handleReviewModalClick();
      }
    };

    document.addEventListener('keydown', handleEscPress, false);

    return () => {
      document.removeEventListener('keydown', handleEscPress, false);
    };
  }, [isVisible, handleReviewModalClick]);

  const handleReviewClick = (review) => {
    const newRevState = reviews.map((e) => {
      if (e.id === review.id) {
        return { ...e, showLong: true };
      }

      return e;
    });

    setReviewsState(newRevState);
  };

  const renderShortReviewContent = (review) => (
    <div>
      <div className="hotel_rev_text mb_12">{review.short}</div>
      {review.isLong && (
        <button
          type="button"
          className="hotel_rev_read_more"
          onClick={() => handleReviewClick(review)}
        >
          <div className="hotel_rev_ream_more dbr_text_16">{READ_MORE}</div>
          <BlueArrow className="hotel_rev_read_more_ico" />
        </button>
      )}
    </div>
  );

  const renderLongReviewContent = (review) => (
    <div>
      <div className="hotel_rev_text">{review.long}</div>
      {review.positive && (
        <div className="hotel_rev_text_block">
          <div className="bm_text_16 mb_4">{`${PLUS}:`}</div>
          <div className="hotel_rev_text">{review.positive}</div>
        </div>
      )}
      {review.negative && (
        <div className="hotel_rev_text_block">
          <div className="bm_text_16 mb_4">{`${MINUS}:`}</div>
          <div className="hotel_rev_text">{review.negative}</div>
        </div>
      )}
    </div>
  );

  const getRateColor = (rate) => {
    if (parseInt(rate, 10) > 3) {
      return 'hotel_rev_green_rate';
    }

    return 'hotel_rev_yellow_rate';
  };

  const renderReviews = (rev) =>
    rev.map((review, index) => (
      <div key={`review-${index}`} className="hotel_rev_review_item">
        <div className="hotel_rev_review_first_col">
          {review.rate > 0 && (
            <div
              className={`hotel_rev_rating wm_text_18 ${getRateColor(
                review.rate,
              )}`}
            >
              {review.rate}
            </div>
          )}

          <div className="gr_text_14">{review.reviewDate}</div>
        </div>
        <div className="hotel_rev_review_second_col">
          <div className="hotel_rev_user_name_line">
            <img alt="" src={UserLogo} className="hotel_rev_user_logo" />
            {review.name && (
              <div className="bm_text_16">{review.name}</div>
            )}
          </div>

          <div className="br_text_16">
            {review.showLong
              ? renderLongReviewContent(review)
              : renderShortReviewContent(review)}
          </div>
        </div>
      </div>
    ));

  return (
    <div
      className={`hotel_rev_modal_container ${
        isVisible ? 'hotel_rev_modal_open' : ''
      }`}
    >
      <div
        className="hotel_rev_modal hotel_rev_review_modal_cont"
        ref={(node) => {
          reviewModalNode.current = node;
        }}
      >
        <div className="hotel_rev_modal_title_line">
          <div className="hotel_rev_modal_title">{GUEST_REVIEWS}</div>
          <button
            type="button"
            className="hotel_rev_close_but"
            onClick={handleReviewModalClick}
          >
            <Close />
          </button>
        </div>
        <div className="hotel_rev_rev_w blue_scroll_container">
          {renderReviews(reviews)}
        </div>
      </div>
    </div>
  );
}

HotelReviewsModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  reviewModalNode: PropTypes.instanceOf(Object).isRequired,
  handleReviewModalClick: PropTypes.func.isRequired,
  reviews: PropTypes.instanceOf(Array).isRequired,
  setReviewsState: PropTypes.func.isRequired,
};

export default HotelReviewsModal;
